import BasicDomain from "./BasicDomain";
import CommonUtils from "utils/CommonUtils";
import * as yup from 'yup';

export default class Evidence extends BasicDomain {
    static DEFAULTS = {
        label: ''
    }

    static VALIDATION_SCHEMA = yup.object({
        label: yup.string().required('Label is required'),
        formatId: yup.object().required('Format is required'),
        sourceOwned: yup.object().required('Source owned is required'),
        repository: yup.object().required('Repository is required'),
        observation: yup.object().required('Observation is required'),
    }).required();

    constructor(props) {
        super('Evidence', props, Evidence.DEFAULTS);
    }

    getTableValues = () => {
        const type = this.get('evidenceFormat')
        
        switch (type.get('filteredFor')) {
            case 'File':
                return {    
                    id: this.id,
                    name: this.get('label') || '',
                    format: this.get('evidenceFormat')?.get('shortCode') || '',
                    title: this.get('file')?.name  || '',
                    repository: '',
                    personName: '',
                    date: CommonUtils.formatDate(this.get('createdAt'), 'yyyy-mm-dd') || '',
                }
            case 'Literature':
                const authors = this.get('literature')?.get('authoredBy') || [];
                const authorNames = authors.map(author => (author.get('firstName') || '') + ' ' + (author.get('lastName') || '')).join(', ');
                return {    
                    id: this.id,
                    name: this.get('label') || '',
                    format: this.get('evidenceFormat')?.get('shortCode') || '',
                    title: this.get('literature')?.get('title') || '',
                    repository: '',
                    personName: authorNames,
                    date: CommonUtils.formatDate(this.get('createdAt'), 'yyyy-mm-dd') || '',
                }
            case 'Voucher':
                return {
                    id: this.id,
                    name: this.get('label') || '',
                    format: this.get('evidenceFormat')?.get('shortCode') || '',
                    title: this.get('catalogNumber')?.get('name') || '',
                    repository: this.get('voucher')?.get('repository')?.get('label') || '',
                    personName: '',
                    date: CommonUtils.formatDate(this.get('createdAt'), 'yyyy-mm-dd') || '',
                }
            default:
                return {}
        }
    }
}

if (global.Parse.Object.registerSubclass) {
    global.Parse.Object.registerSubclass('Evidence', Evidence);
}